export const buildPath = (path: string, params: Record<string, string>) => {
    let newPath = path;
    for (const i in params) {
        newPath = newPath.replace(new RegExp(':' + i, 'g'), params[i]);
    }

    return newPath;
};
